import PorTalManage from './index';
import AppHome from './AppHomePage/appHome';
import ListConf from "./ListConf";

export default {
    path : '/portal',
    component: PorTalManage,
    children:[
        {path: '/portal/app/home',component: AppHome},
        {path: '/portal/listConf',component: ListConf},
    ]
}
